enum QUERY_KEYS {
  GET_MOCK_DATA = 'GET_MOCK_DATA',
  GET_ME = 'GET_ME',
  GET_FLOORS = 'GET_FLOORS',
  GET_CATEGORIES = 'GET_CATEGORIES'
}

export default QUERY_KEYS;
